module.exports = __webpack_public_path__ + "static/Obóz 2024 - ulotka-f3ab6b4101932cc7b13caaf033bd01f3.jpg";